import * as React from 'react';
import Modal from 'src/components/common/Modal';
import FoundInModels from 'src/components/FoundInModels';
import Carousel from 'src/components/PartDetails/components/Carousel';
import Button from 'src/components/common/Button';
import Alert from 'src/components/common/Alert';
import IconMessage from 'src/components/common/IconMessage';
import Tabs from 'src/components/common/Tabs';
import AlternatesParts from 'src/components/PartDetails/components/AlternatesParts';
import PickUpTab from 'src/components/PartDetails/components/PickUpTab';
import ShipFromTab from 'src/components/PartDetails/components/ShipFromTab';

import { IWarrantyProvider } from 'src/model/warranty.model';
import { IExtraProduct } from 'src/model/productdetails.model';

import defaultImage from 'src/assets/defaultImage';
import './PartDetailsDesktop.scss';
import ProductManufacturer from 'src/model/productManufacturer.model';
import Select2 from 'src/components/common/Select2';
import { ISelectOption } from 'src/components/common/Select2/components/SelectOption/SelectOption';
import AddToListMenu from 'src/components/AddToListMenu';
import Checkbox from '../../common/Checkbox';
import env from 'src/shared/env';
import accounting from 'accounting';
import i18n from 'src/translation/i18n';
import { goToPartDetail, partDetailUrl } from 'src/utils/navigation';
import DeliveryTab from '../components/DeliveryTab';
import { getItemCount } from 'src/store/modules/cart/actions';
import dropShipIcon from 'src/assets/dropship';

export function getExtraStatus(extraProducts: IExtraProduct[]): string {
  let core = -1;
  let oversized = -1;
  let freon = -1;
  let desc = '';
  let retailsPrice = '';

  extraProducts.forEach(product => {
    core = product.componentCode.toLowerCase().search('core');
    oversized = product.componentCode.toLowerCase().search('dw');
    freon = product.componentCode.toLowerCase().search('freon');
    retailsPrice=product.retailPrice;
  });
  if (core > -1) {
    desc = 'core';
  } else if (oversized > -1) {
    desc = 'oversized item';
  } else if (freon > -1) {
    desc = 'freon';
  } else if (extraProducts.length) {
    if(retailsPrice==='0'){
      desc = 'DONOTSHOW';
    }else{
      desc = 'additional charge';
    }
    
  }

  return desc;
}

export function getExtraComponentCode(extraProducts: IExtraProduct[]): string {
  
  let componentCodeFreight = ''; 

  extraProducts.forEach(product => {
    if(product.componentCode === "OVERSIZE" || product.productNumber.includes("OVERSIZE") || product.description.includes("OVERSIZE") || product.componentCode.includes("OVERSIZE")) {
      componentCodeFreight = "OVERSIZE";
    }
  });
   return componentCodeFreight;
}
export function getExtraComponentCodePrice(extraProducts: IExtraProduct[]): number {
  
  let componentCodePartnerPrice=0;

  extraProducts.forEach(product => {
    if(product.componentCode === "OVERSIZE1" || product.productNumber.includes("OVERSIZE") || product.description.includes("OVERSIZE") || product.componentCode.includes("OVERSIZE")) {
      componentCodePartnerPrice = parseFloat(product.partnerPrice);
    }
  });
   return componentCodePartnerPrice;
}

export interface IPart {
  images: string[];
  modelsFound: number;
  name: string;
  notes: string;
  productNumber: string;
  description: string;
  price: number;
  msrp: number;
  inStock: boolean;
  supplierQuantity: number;
  state: string;
  extraProducts: IExtraProduct[];
  extraTotalAmount: number;
  pickUpFrom: string; 
  pickUpTo: string;
  shipFrom: string;
  shipToName: string;
  shipToAddress: string;
  manufacturer?: string;
  manufacturerCode?: string;
  alternateproductnumber?: string;
  alternatemfc?: string;
  replacementMfc?: string;
  replacementPart?: string;
  oemProductNumber?: string;
  oemProductManufacturer?: string;
  replacedPart: string;
  replacedMfc: string;
  stateDescription: string;
  specialOrder: boolean;
  isDropShip: boolean;
  discountInfo: any;
  orderDetailStatus: string;
  deliveryFrom: string;
  deliveryTo: string;
  alternateParts: any[];
  longDesc: string;
  subPartNumber: string;
  weight: string;
  length: string;
  width: string;
  height: string;
}

interface IPartDetailsDesktopProps {
  manufacturers: ProductManufacturer[];
  orgPartnum: string;
  orgPartmfc: string;
  selectedManufacturer: ProductManufacturer;
  qty: number;
  shipmentMarking: string;
  ticketNumber: string;
  warrantyProvider: string;
  claims: string;
  backorder: boolean;
  rushOrder: boolean;
  deliverMethod: string;
  part: IPart;
  showOnlyMSRP: boolean;
  isLoggedIn: boolean;
  isLoadingAddToCart: boolean;
  addedToCart: boolean;
  cartAlertType: string;
  t: any;
  handleChangeShipFrom(): void;
  handleChangeShipTo(): void;
  handleChangePickUp(): void;
  handleShipmentMarkingChange(shipmentMarking: string): void;
  handleTicketNumberChange(ticketNumber: string): void;
  handleWarrantyProviderChange(warranty: IWarrantyProvider): void;
  handleClaimsChange(claims: string): void;
  handleRushOrderChange(rushOrder: boolean): void;
  handleDeliverMethodChange(deliverMethod: string): void;
  handleAddToCart(): void;
  onSelectMfc: (item: ProductManufacturer) => void;
  warranties: IWarrantyProvider[];
  getWarranties: () => void;
  defaultWarehouse: any;
  // PICK-UP PROPS
  pickUpAddresses: any[];
  onClosePickUp: () => void;
  handleChangePickUpTab: (shipFromAddress: {
    [key: string]: { qty: string; available: number };
  }) => void;
  selectedShipFrom: object;
  selectedPickUp: string;
  // SHIP FROM PROPS
  shipFromAddresses: any[];
  onCloseShipFrom: () => void;
  handleChangeShipFromTab: (address: object) => void;
  type: 'shipping' | 'pick-up' | '' | 'delivery';
  buttonVerbiage: string;
  supplierQuantity: number;
  selectedAddresses: object;
  setAddToCartState: (value: boolean) => void;
  isAddedToCart: boolean;
  setResetPickUpAction: (fn: () => void) => void;
  getPickUpAddresses: () => void;
  getShipFromAddresses: () => void;
  cartDeliverMethod: 'shipping' | 'pick-up' | '' | 'delivery';
  handleDeliveryChange: (shipFromAddress: {
    [key: string]: { qty: string; available: number };
  }) => void;
  isDelivery: boolean;
  handleDeliverySuppliedFromChange: (shipFromAddress: {
    [key: string]: { qty: string; available: number };
  }) => void;
  deliveryAddresses: any[];
  getDeliveryFromAddresses: () => void;
  deliveryFromOrder: any;
  selectedDelivery: string;
  handleScrollToLongDesc: () => void;
}

interface IPartDetailsDesktopState {
  mainImage: string;
  indexImage: number;
  showModalImage: boolean;
  showDropDown: boolean;
  showFoundIn: boolean;
  disableShipmentMarking: boolean;
  showButtonAlert: boolean;
  isPickUpMounted: boolean;
  isShipMounted: boolean;
  shipFromAddress: {};
  selectedAddresses: any;
  oempartnum: string;
  oempartmfc: string;
  // oempartnumother:string;
  // oempartmfcother:string;
  deliverFromAddress: {};
  isOpen: boolean;
}

export function selectedMfgToOption(mfg: ProductManufacturer): ISelectOption {
  if (mfg == null) {
    return null;
  }
  const mfgName = mfg.manufacturerName || mfg.manufacturerCode;
  return {
    value: mfg,
    name: `${mfgName} ${mfg.productNumber}`
  };
}

class PartDetailsDesktop extends React.Component<
  IPartDetailsDesktopProps,
  IPartDetailsDesktopState
> {
  private formRef: any;

  constructor(props: any) {
    super(props);
    this.state = {
      mainImage: this.getMainImage(),
      indexImage: 0,
      showModalImage: false,
      showDropDown: false,
      showFoundIn: false,
      disableShipmentMarking: false,
      showButtonAlert: false,
      isPickUpMounted: false,
      isShipMounted: false,
      shipFromAddress: {},
      selectedAddresses: this.props.selectedAddresses,
      oempartnum: '',
      oempartmfc: '',
      // oempartmfcother:localStorage.getItem('orgPartmfc'),
      // oempartnumother:localStorage.getItem('orgPartnum')
      deliverFromAddress: {},
      isOpen:false
    };
  }

  private calculateTranslation(): number {
    return this.state.indexImage * -100;
  }

  private getMainImage = () => {
    return this.props.part.images
      ? this.props.part.images[0]
        ? this.props.part.images[0]
        : defaultImage
      : defaultImage;
  };

  private handleInputShipmentMarkingChange = (e: any) => {
    this.props.handleShipmentMarkingChange(e.target.value);
  };

  private handleInputTicketNumberChange = (e: any) => {
    this.props.handleTicketNumberChange(e.target.value);
  };

  private handleSelectWarrantyProviderChange = (
    warranty: IWarrantyProvider
  ) => {
    if (!warranty.providerNumber) {
      this.setState({ disableShipmentMarking: false });
    } else {
      this.setState({ disableShipmentMarking: true });
    }
    this.props.handleWarrantyProviderChange(warranty);
  };

  private handleInputClaimsChange = (e: any) => {
    this.props.handleClaimsChange(e.target.value);
  };

  private handleRushOrderChange = (e: any) => {
    this.props.handleRushOrderChange(e.target.checked);
  };

  private handleSubmit = (e: any) => {
    e.preventDefault();
    if (this.checkForErrors()) {
      return;
    }
    this.props.handleAddToCart();
  };
  private viewbutton = (e: any) => {
    this.setState({
      oempartnum: this.props.part.name,
      oempartmfc: this.props.part.manufacturerCode
    });
    goToPartDetail(
      `${this.props.part.alternatemfc}  ${this.props.part.alternateproductnumber}`
    );
  };
  private viewbuttonoem = (e: any) => {
    goToPartDetail(`${this.state.oempartmfc}  ${this.state.oempartnum}`);
    this.setState({
      oempartnum: '',
      oempartmfc: ''
    });
  };
  // private viewbuttonoemother=(e:any)=>{

  // goToPartDetail(`${this.props.orgPartmfc}  ${this.props.orgPartnum}`)

  // }
  public checkForErrors() {
    let ismarkingError: boolean = false;
    if (
      this.state.disableShipmentMarking &&
      this.props.claims &&
      this.props.claims.length > 15
    ) {
      ismarkingError = true;
      this.props.handleClaimsChange(this.props.claims);
    }
    return ismarkingError;
  }

  private handleClicMiniImage = (image: string, index: number) => {
    this.setState({
      mainImage: image,
      indexImage: index
    });
  };

  private handleClicMainImage = () => {
    if (this.props.part?.images === null) {
      return;
    }
    this.setState({ showModalImage: true });
  };

  private handleCloseImageModal = () => {
    this.setState({ showModalImage: false });
  };

  private handleShowDropDown = () => {
    this.setState(prevState => {
      return { showDropDown: !prevState.showDropDown };
    });
  };

  private handleFoundIn = () => {
    this.setState(prevState => ({ showFoundIn: !prevState.showFoundIn }));
  };

  public componentDidMount() {
    this.props.getWarranties();
    this.setState({
      isPickUpMounted: true,
      isShipMounted: true
    });
    this.props.setResetPickUpAction(this.setDefaultValues);

  }

  public componentDidUpdate(prevProps: any) {
    if (this.props.part !== prevProps.part) {
      this.setState({ mainImage: this.getMainImage() });
    }

    if (this.props.part.name !== prevProps.part.name) {
      this.setDefaultValues();
    }
  }

  public selectTab = (index: number) => {
    this.props.handleDeliverMethodChange(
      index === 1 ? 'shipping' : index === 2 ? 'delivery' : 'pick-up'
    );
  };

  private handleOnInputChange = (
    warehouse: string,
    qty: string,
    available: number,
    setAlert: (params: any) => void
  ) => {
    if (/^([0-9])*$/.test(qty)) {
      if (qty === '' || qty === '0') {
        const temp = { ...this.state.shipFromAddress };
        delete temp[warehouse];
        this.setState(
          {
            shipFromAddress: temp
          },
          () => {
            this.props.handleChangePickUpTab(this.state.shipFromAddress);
          }
        );
        setAlert({ show: false, type: '', message: '' });
      } else {
        if (Number(qty) > available) {
          setAlert({
            show: true,
            type: 'info',
            message:
              env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                ? `${i18n.t('common.itemsBackOrderedOnly')}`
                : `${Number(qty) -
                    available} item(s) will be backordered. We will ship them as soon as the stocks are available for shipment.`
          });
        } else {
          setAlert({ show: false, type: '', message: '' });
        }

        this.setState(
          prevState => ({
            shipFromAddress: {
              ...prevState.shipFromAddress,
              [warehouse]: { qty, available }
            }
          }),
          () => {
            this.props.handleChangePickUpTab(this.state.shipFromAddress);
          }
        );
      }
    }
  };

  private handleOnDeliveryInputChange = (
    warehouse: string,
    qty: string,
    available: number,
    setAlert: (params: any) => void
  ) => {
    if (/^([0-9])*$/.test(qty)) {
      if (qty === '' || qty === '0') {
        const temp = { ...this.state.deliverFromAddress };
        delete temp[warehouse];
        this.setState(
          {
            deliverFromAddress: temp
          },
          () => {
            this.props.handleDeliverySuppliedFromChange(
              this.state.deliverFromAddress
            );
          }
        );
        setAlert({ show: false, type: '', message: '' });
      } else {
        if (Number(qty) > available) {
          setAlert({
            show: true,
            type: 'info',
            message:
              env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                ? `${i18n.t('common.itemsBackOrderedOnly')}`
                : `${Number(qty) -
                    available} item(s) will be backordered. We will ship them as soon as the stocks are available for shipment.`
          });
        } else {
          setAlert({ show: false, type: '', message: '' });
        }

        this.setState(
          prevState => ({
            deliverFromAddress: {
              ...prevState.deliverFromAddress,
              [warehouse]: { qty, available }
            }
          }),
          () => {
            this.props.handleDeliverySuppliedFromChange(
              this.state.deliverFromAddress
            );
          }
        );
      }
    }
  };

  private setWarehouseValue = (warehouses: any, i: number) => {
    this.setState(
      {
        shipFromAddress: {
          [warehouses[i].warehouseCode]: {
            qty: 1,
            available: warehouses[i].quantity
          }
        }
      },
      () => {
        this.props.handleChangePickUpTab(this.state.shipFromAddress);
      }
    );
  };

  private setDeliveryWarehouseValue = (warehouses: any, i: number) => {
    this.setState(
      {
        deliverFromAddress: {
          [warehouses[i].warehouseCode]: {
            qty: 1,
            available: warehouses[i].quantity
          }
        }
      },
      () => {
        this.props.handleDeliverySuppliedFromChange(
          this.state.deliverFromAddress
        );
      }
    );
  };

  private setShippingValues = () => {
    const shipFromTabWarehouses =
      env.REACT_APP_BASE_ENVIRONMENT === 'CA'
        ? this.getCAShipFromTabWarehouses()
        : this.getShipFromTabWarehouses();

    if (shipFromTabWarehouses.length) {
      if (Number(shipFromTabWarehouses[0].quantity) !== 0) {
        this.setShipFromTabWarehouseValue(shipFromTabWarehouses, 0);
      } else if (
        shipFromTabWarehouses.length > 1 &&
        Number(shipFromTabWarehouses[1].quantity) !== 0
      ) {
        this.setShipFromTabWarehouseValue(shipFromTabWarehouses, 1);
      } else {
        this.setShipFromTabWarehouseValue(shipFromTabWarehouses, 0);
      }
    }
  };

  private setPickUpValues = () => {
    let warehouse;
    let countwarehouse = 0;
    const warehouses =
      env.REACT_APP_BASE_ENVIRONMENT === 'CA'
        ? this.getfilteredPickUpCAWarehouses()
        : this.getWarehouses();

    if (warehouses.length) {
      if (Number(warehouses[0].quantity) !== 0) {
        this.setWarehouseValue(warehouses, 0);
      } else if (warehouses.length > 1) {
        if (Number(warehouses[1].quantity) !== 0) {
          this.setWarehouseValue(warehouses, 1);
        }
      } else {
        this.setWarehouseValue(warehouses, 0);
      }
      for (warehouse = 0; warehouse < warehouses.length; warehouse++) {
        if (warehouses[warehouse].quantity === '0') {
          countwarehouse++;
        }
      }
      if (countwarehouse === warehouses.length) {
        this.setWarehouseValue(warehouses, 0);
      }
    }
  };

  private setDeliveryValues = () => {
    const warehouses =
      env.REACT_APP_BASE_ENVIRONMENT === 'CA'
        ? this.getfilteredPickUpCAWarehouses()
        : this.getDeliveryWarehouses();
    if (warehouses.length) {
      if(warehouses.length===1){
        if (Number(warehouses[0].quantity) !== 0) {
          this.setDeliveryWarehouseValue(warehouses, 0);
        }else {
          this.setDeliveryWarehouseValue(warehouses, 0);
        }
      }else{
      if (Number(warehouses[0].quantity) !== 0) {
        this.setDeliveryWarehouseValue(warehouses, 0);
      } else if (Number(warehouses[1].quantity) !== 0) {
        this.setDeliveryWarehouseValue(warehouses, 1);
      } else {
        this.setDeliveryWarehouseValue(warehouses, 0);
      }
    }
    }
  };

  public getfilteredPickUpCAWarehouses = () => {
    const warehouses = this.getWarehouses();
    return warehouses.filter(
      warehouseObj =>
        (this.props.selectedPickUp === warehouseObj?.code &&
          warehouseObj?.pickUpOnly) ||
        !warehouseObj?.pickUpOnly
    );
  };

  private setDefaultValues = () => {
    if (this.props.deliverMethod === 'pick-up') {
      this.setShippingValues();
      this.setPickUpValues();
    } else if (this.props.deliverMethod === 'shipping') {
      this.setPickUpValues();
      this.setShippingValues();
    } else if (this.props.deliverMethod === 'delivery') {
      this.setShippingValues();
      this.setPickUpValues();
      this.setDeliveryValues();
    }
  };

  private filterStocked = (list: any[]) => {
    const stocked: any[] = [];
    const notStocked: any[] = [];

    list.forEach(el => {
      if (!el.pickUpOnly) {
        if (Number(el.quantity) !== 0) {
          stocked.push(el);
        } else {
          notStocked.push(el);
        }
      }
    });

    return [...stocked, ...notStocked];
  };

  private getWarehouses = () => {
    if (env.REACT_APP_BASE_ENVIRONMENT === 'CA') {
      return [
        this.props.pickUpAddresses[0],
        ...this.filterCAPickupAddresses(this.props.pickUpAddresses.slice(1))
      ];
    } else {
      return [
        this.props.pickUpAddresses[0],
        ...this.filterStocked(this.props.pickUpAddresses.slice(1))
      ];
    }
  };

  private getDeliveryWarehouses = () => {
    if (env.REACT_APP_BASE_ENVIRONMENT === 'CA') {
      return [
        this.props.deliveryAddresses[0],
        ...this.filterCAPickupAddresses(this.props.deliveryAddresses.slice(1))
      ];
    } else {
      return [
        this.props.deliveryAddresses[0],
        ...this.filterStocked(this.props.deliveryAddresses.slice(1))
      ];
    }
  };

  private getShipFromTabWarehouses = () => {
    let defaultWarehouse = {};
    const stocked: any[] = [];
    const notStocked: any[] = [];

    if (this.props.defaultWarehouse.warehouseCode) {
      this.props.shipFromAddresses.forEach(shipAddress => {
        if (
          shipAddress.warehouseCode ===
          this.props.defaultWarehouse.warehouseCode
        ) {
          defaultWarehouse = shipAddress;
        } else if (Number(shipAddress.quantity) !== 0) {
          stocked.push(shipAddress);
        } else {
          notStocked.push(shipAddress);
        }
      });

      return [defaultWarehouse, ...stocked, ...notStocked];
    } else {
      return this.filterStocked(this.props.shipFromAddresses);
    }
  };

  private getCAShipFromTabWarehouses = () => {
    let defaultWarehouse = {};
    const stocked: any[] = [];
    const notStocked: any[] = [];
    const distributionCenters: any[] = [];

    if (this.props.defaultWarehouse.warehouseCode) {
      // const ShippingAddresses = this.props.shipFromAddresses.sort((a, b) => a.pickUpOnly - b.pickUpOnly);
      this.props.shipFromAddresses.forEach(shipAddress => {
        if (
          shipAddress.warehouseCode ===
          this.props.defaultWarehouse.warehouseCode
        ) {
          defaultWarehouse = shipAddress;
        } else if (
          (Number(shipAddress.quantity) === 0 && !shipAddress.pickUpOnly) ||
          (Number(shipAddress.quantity) !== 0 && !shipAddress.pickUpOnly)
        ) {
          distributionCenters.push(shipAddress);
        } else if (Number(shipAddress.quantity) !== 0) {
          stocked.push(shipAddress);
        } else {
          notStocked.push(shipAddress);
        }
      });
      return [
        defaultWarehouse,
        ...distributionCenters,
        ...stocked,
        ...notStocked
      ];
    } else {
      return this.filterShippingAddresses(this.props.shipFromAddresses);
    }
  };

  private filterShippingAddresses = (shippingAddresses: any[]) => {
    const stocked: any[] = [];
    const notStocked: any[] = [];
    const distributionCenters: any[] = [];

    shippingAddresses.forEach(el => {
      if (
        (Number(el.quantity) === 0 && !el.pickUpOnly) ||
        (Number(el.quantity) !== 0 && !el.pickUpOnly)
      ) {
        distributionCenters.push(el);
      } else if (Number(el.quantity) !== 0) {
        stocked.push(el);
      } else {
        notStocked.push(el);
      }
    });

    return [...distributionCenters, ...stocked, ...notStocked];
  };

  private filterCAPickupAddresses = (list: any[]) => {
    const stocked: any[] = [];
    const notStocked: any[] = [];

    list.forEach(el => {
      if (Number(el.quantity) !== 0) {
        stocked.push(el);
      } else {
        notStocked.push(el);
      }
    });

    return [...stocked, ...notStocked];
  };

  private setShipFromAddress = (shipFromAddress: any) => {
    this.setState({
      shipFromAddress
    });
  };

  private setDeliverFromAddress = (deliverFromAddress: any) => {
    this.setState({
      deliverFromAddress
    });
  };

  private handleShipFromTabInputChange = (
    warehouse: string,
    qty: string,
    available: number,
    setAlert: (params: any) => void
  ) => {
    if (/^([0-9])*$/.test(qty)) {
      if (qty === '' || qty === '0') {
        const temp = { ...this.state.selectedAddresses };
        delete temp[warehouse];
        this.setState(
          {
            selectedAddresses: temp
          },
          () => {
            this.props.handleChangeShipFromTab(this.state.selectedAddresses);
          }
        );
        setAlert({ show: false, type: '', message: '' });
      } else {
        if (Number(qty) > available) {
          setAlert({
            show: true,
            type: 'info',
            message:
              env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                ? `${i18n.t('common.itemsBackOrderedOnly')}`
                : `${Number(qty) -
                    available} item(s) will be backordered. We will ship them as soon as the stocks are available for shipment.`
          });
        } else {
          setAlert({ show: false, type: '', message: '' });
        }
        this.setState(
          prevState => {
            return {
              selectedAddresses: {
                ...prevState.selectedAddresses,
                [warehouse]: { qty, available }
              }
            };
          },
          () => {
            this.props.handleChangeShipFromTab(this.state.selectedAddresses);
          }
        );
      }
    }
  };

  private setShipFromTabWarehouseValue = (warehouses: any, i: number) => {
    this.setState(
      {
        selectedAddresses: {
          [warehouses[i].warehouseCode]: {
            qty: 1,
            available: warehouses[i].quantity
          }
        }
      },
      () => {
        this.props.handleChangeShipFromTab(this.state.selectedAddresses);
      }
    );
  };

  private setSelectedAddresses = (selectedAddresses: any) => {
    this.setState({
      selectedAddresses
    });
  };

  public renderChangePickUp() {
    return (
      <PickUpTab
        deliverAddresses={this.props.pickUpAddresses}
        defaultWarehouse={this.props.defaultWarehouse}
        supplierQuantity={this.props.supplierQuantity}
        handleChangeAddress={this.props.handleChangePickUpTab}
        selectedShipFrom={this.props.selectedShipFrom}
        selectedPickup={this.props.selectedPickUp}
        part={this.props.part}
        handleChangePickUp={this.props.handleChangePickUp}
        isAddedToCart={this.props.isAddedToCart}
        setAddedToCart={this.props.setAddToCartState}
        isMounted={this.state.isPickUpMounted}
        setMounted={(val: boolean) => this.setState({ isPickUpMounted: val })}
        defaultItemsToShow={4}
        handleOnInputChange={this.handleOnInputChange}
        setDefaultValues={this.setDefaultValues}
        getWarehouses={this.getWarehouses}
        shipFromAddress={this.state.shipFromAddress}
        setShipFromAddress={this.setShipFromAddress}
        getPickUpAddresses={this.props.getPickUpAddresses}
        cartDeliverMethod={this.props.cartDeliverMethod}
      />
    );
  }

  public renderChangeShipFrom() {
    return (
      <ShipFromTab
        deliverAddresses={this.props.shipFromAddresses}
        defaultWarehouse={this.props.defaultWarehouse}
        supplierQuantity={this.props.supplierQuantity}
        handleChangeAddress={this.props.handleChangeShipFromTab}
        showPickUpOnly={false}
        type={this.props.type}
        selectedtab={this.setCurrentTab()}
        selectedAddresses={this.state.selectedAddresses}
        setSelectedAddresses={this.setSelectedAddresses}
        part={this.props.part}
        handleChangeShipTo={this.props.handleChangeShipTo}
        isAddedToCart={this.props.isAddedToCart}
        setAddedToCart={this.props.setAddToCartState}
        isMounted={this.state.isShipMounted}
        setMounted={(val: boolean) => this.setState({ isShipMounted: val })}
        defaultItemsToShow={4}
        handleOnInputChange={this.handleShipFromTabInputChange}
        setDefaultValues={this.setDefaultValues}
        getWarehouses={
          env.REACT_APP_BASE_ENVIRONMENT === 'CA'
            ? this.getCAShipFromTabWarehouses
            : this.getShipFromTabWarehouses
        }
        getShipFromAddresses={this.props.getShipFromAddresses}
        cartDeliverMethod={this.props.cartDeliverMethod}
      />
    );
  }

  public renderDeliveryFrom() {
    return (
      <DeliveryTab
        deliverAddresses={this.props.deliveryAddresses}
        defaultWarehouse={this.props.defaultWarehouse}
        supplierQuantity={this.props.supplierQuantity}
        handleChangeAddress={this.props.handleDeliverySuppliedFromChange}
        selectedShipFrom={this.props.deliveryFromOrder}
        selectedPickup={this.props.selectedDelivery}
        part={this.props.part}
        isAddedToCart={this.props.isAddedToCart}
        setAddedToCart={this.props.setAddToCartState}
        isMounted={this.state.isPickUpMounted}
        setMounted={(val: boolean) => this.setState({ isPickUpMounted: val })}
        defaultItemsToShow={4}
        handleOnInputChange={this.handleOnDeliveryInputChange}
        setDefaultValues={this.setDefaultValues}
        getWarehouses={this.getDeliveryWarehouses}
        shipFromAddress={this.state.deliverFromAddress}
        setShipFromAddress={this.setDeliverFromAddress}
        getPickUpAddresses={this.props.getDeliveryFromAddresses}
        cartDeliverMethod={this.props.cartDeliverMethod}
      />
    );
  }

  private handleSelectMfc = (item: ISelectOption) => {
    this.props.onSelectMfc(item.value);
  };

  private showButtonAlert = () => {
    this.setState({ showButtonAlert: true }, () => {
      setTimeout(() => {
        this.setState({ showButtonAlert: false });
      }, 3000);
    });
  };

  public handleKeyDown= (event:any) => {
    if(event.keyCode === 13) {
      this.getAddToCartButton();
    }
  }

  private getAddToCartButton = () => {
    const { t } = this.props;
    if (
      this.props.addedToCart &&
      this.props.cartAlertType === 'success' &&
      this.state.showButtonAlert
    ) {
	  // created by Omveer Chaudhary
      sessionStorage.setItem("DeliveryCheck",'');
      return (
        <div className="success-button-alert">
          <i className="rpds-check-circle" />
          {t('common.itemsAddedToCart')}
        </div>
      );
    } else {
      const addCartButtonStatusDisabled =
        (this.props.shipFromAddresses.length === 0 &&
          this.props.pickUpAddresses.length === 0) ||
        !this.props.qty ||
        this.props.isLoadingAddToCart
          ? true
          : false;
      return (
        <Button
          buttonClass="primary-custom-button rp-part-details-desktop--form--button"
          height="56px"
          disabled={addCartButtonStatusDisabled}
          label={t('common.addToCart')}
          icon={{ position: 'left', icon: 'rpds-shopping-cart' }}
          action={() => {
            if (this.checkForErrors()) {
              return;
            }
            this.props.handleAddToCart();
            this.showButtonAlert();
          }}
          textTransform="uppercase"
        />
      );
    }
  };

  private getIcon(): string {
    if (this.props.part.inStock) {
      return 'rpds-check-circle stock-success-icon';
    }
    // else if (this.props.part.specialOrder) {
    //   return 'rpds-error stock-error-icon';
    // }
    else if (this.props.part.state === 'No Longer Available') {
      return 'rpds-close stock-close-icon';
    } else if (this.props.part.state === 'Backorder') {
      return 'rpds-remove stock-remove-icon';
    } else {
      return 'rpds-error stock-error-icon';
    }
  }

  private setCurrentTab = (): number => {
    if (this.props.deliverMethod === 'delivery') {
      return 2;
    } else if (this.props.deliverMethod === 'shipping') {
      return 1;
    } else if (this.props.deliverMethod === 'pick-up') {
      return 0;
    } else {
      return -1;
    }
  };

  public getPartState(state: string): string {
    const { t } = this.props;
    if (!state) {
      return state;
    }
    switch (state.toLowerCase()) {
      case 'in stock':
        return t('common.inStock');
      case 'out of stock':
        return t('common.outOfStock');
      case 'backordered':
        return t('cartPage.backOrdered');
      default:
        return state;
    }
  }

  public renderMfc() {
    if (
      this.props.manufacturers != null &&
      this.props.manufacturers.length > 1
    ) {
      const options = this.props.manufacturers.map(selectedMfgToOption);
      return (
        <div className="rp-part-details-desktop--info--product-number">
          <Select2
            label={''}
            options={options}
            selected={selectedMfgToOption(this.props.selectedManufacturer)}
            onSelect={this.handleSelectMfc}
          />
        </div>
      );
    }
    return (
      <p className="rp-part-details-desktop--info--product-number">
        {this.props.part.productNumber}
      </p>
    );
  }

  private goToPartDetailsFromBreadCrumb=(productNumber:any)=>{
    goToPartDetail(decodeURIComponent(productNumber));
  }

  private renderBreadCrumb= () =>{
    let breadCrumbArr:any=[];
    const getFromStorage=sessionStorage.getItem("bredcrumbKey");
    if(getFromStorage!==""){
      breadCrumbArr=getFromStorage.split("==");
    } 
    if(breadCrumbArr[1]!==""){
    return(
        <span>
          <a onClick={e => this.goToPartDetailsFromBreadCrumb(breadCrumbArr[1])}>Back to Main Part</a>
      </span>
    );
    }else{
      return null;
    }
   }

  private handleToggleReadMore = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  public render() {
    const { t } = this.props;

    const tabContents = [
      this.renderChangePickUp(),
      this.renderChangeShipFrom()
    ];

    const tabTitles = [
      {
        title: `${(t('product.pickUpStoreTab') as string).toUpperCase()}`,
        count: this.props.pickUpAddresses.length,
        showCount: false
      },
      {
        title: `${(t('product.shippingTab') as string).toUpperCase()}`,
        count: this.props.shipFromAddresses.length,
        showCount: false
      }
    ];

    if (this.props.isDelivery) {
      tabContents.push(this.renderDeliveryFrom());
      tabTitles.push({
        title: `${t('delivery.delivery')}`,
        count: this.props.pickUpAddresses.length,
        showCount: false
      });
    }

    return (
      <div className="rp-part-details-desktop Roboto">
        {this.state.showFoundIn && (
          <Modal handleCloseModal={this.handleFoundIn}>
            <FoundInModels
              partNumber={
                this.props.part.replacedPart
                  ? this.props.part.replacedPart
                  : this.props.part.name
              }
              modelsQty={this.props.part.modelsFound}
              handleClose={this.handleFoundIn}
            />
          </Modal>
        )}
        <div className="d-flex flex-wrap">
          <div className="rp-part-details-desktop--images">
            <div>
              <div
                className={
                  this.props?.part?.images !== null
                    ? 'image-container'
                    : 'image-container rp-no-hover-image'
                }
                style={{
                  backgroundImage: `url(${this.state.mainImage})`
                }}
                onClick={e => this.handleClicMainImage()}
              >
                {this.props.part.discountInfo && (
                  <span className="rp-part-details-desktop--deal">
                    {t('common.onSale')}{' '}
                  </span>
                )}
              </div>
              <div className="rp-part-details-desktop--mini-images">
                {this.props.part.images && (
                  <Carousel axis="X" swap={16}>
                    {this.props.part.images.map((image, i) => (
                      <div
                        className="rp-part-details-desktop--mini-image"
                        key={i}
                        style={{
                          backgroundImage: `url(${image})`
                        }}
                        onClick={e => this.handleClicMiniImage(image, i)}
                      />
                    ))}
                  </Carousel>
                )}
              </div>
              {this.state.showModalImage && (
                <Modal
                  handleCloseModal={this.handleCloseImageModal}
                  showClose={false}
                >
                  {this.props.part.images && (
                    <div>
                      <Carousel
                        axis="X"
                        swap={100}
                        itemsToShow={this.props.part.images.length}
                        isModal={true}
                        translateTo={this.calculateTranslation()}
                        currentIndex={this.state.indexImage}
                      >
                        {this.props.part.images.map((image, i) => (
                          <img
                            key={i}
                            className="rp-part-details-desktop--modal--image"
                            src={image}
                          />
                        ))}
                      </Carousel>
                      <div
                        onClick={e => this.handleCloseImageModal()}
                        className="rp-part-details-desktop--close-modal"
                      >
                        {(t('common.close') as string).toUpperCase()}{' '}
                        <label className="rpds-close close-modal-icon" />
                      </div>
                    </div>
                  )}
                </Modal>
              )}
              <div className="rp-part-details-desktop--models-info">
                <div
                  className="rp-part-details-desktop--models-info--link"
                  onClick={e => this.handleFoundIn()}
                >
                  {i18n.t('product.foundIn')}{' '}
                  {this.props.part.modelsFound
                    ? this.props.part.modelsFound
                    : 0}{' '}
                  {i18n.t('product.models')}
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="rp-part-details-desktop--info">
              <div className="row">
                <div className="col-8">
                  <div className="d-flex viewbtn-wrapper">
                    <div>
                      <p className="rp-part-details-desktop--info--name">
                        <span>{this.props.part.name}</span>
                      </p>
                      <p className="rp-part-details-desktop--info--description">
                        {this.props.part.description}
                      </p>
                      {this.props.part.name && this.props.part.name==="L13003829" && (
                      <p className="rp-part-details-desktop--note--description">
                        {i18n.t('product.note')}: {i18n.t('product.noteTextForPartL13003829')}
                      </p>
                      )}
                    </div>
                    <div className="d-flex viewbtnchild-wrapper">
                      {this.props.part.replacementMfc &&
                      this.props.part.replacementPart ? (
                        <div className="d-flex button-wrapper">
                          <button
                            className="subavailable"
                            onClick={e =>
                              goToPartDetail(
                                `${this.props.part.replacementMfc}  ${this.props.part.replacementPart}`
                              )
                            }
                          >
                            {t('myFavourites.subavailable')}
                          </button>
                        </div>
                      ) : (
                        ''
                      )}

                      {this.props.part.alternateproductnumber &&
                      !this.props.part.oemProductNumber ? (
                        <div className="d-flex button-wrapper">
                          <button
                            className="viewbutton"
                            type="button"
                            onClick={e =>
                              goToPartDetail(
                                `${this.props.part.alternatemfc}  ${this.props.part.alternateproductnumber}`
                              )
                            }
                          >
                            {t('myFavourites.viewnonoem')}
                          </button>
                        </div>
                      ) : (
                        ''
                      )}
                      {this.props.part.oemProductNumber &&
                      !this.props.part.alternateproductnumber ? (
                        <div className="d-flex button-wrapper">
                          <button
                            className="viewbutton"
                            type="button"
                            onClick={e =>
                              goToPartDetail(
                                `${this.props.part.oemProductManufacturer}  ${this.props.part.oemProductNumber}`
                              )
                            }
                          >
                            {t('myFavourites.viewoem')}
                          </button>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                  {this.renderMfc()}
                </div>
                <div className="col-4">
                  <div className='rp-part-details-desktop--info--stock-text'>
                    <div className="child-icon">
                    <label className="rp-part-details-desktop--info--stock-label">
                          <span
                            title={this.props.part.stateDescription}
                            className={this.getIcon()}
                          />
                          <span
                            title={this.props.part.stateDescription}
                            className="rp-part-details-state"
                          >
                            {this.getPartState(this.props.part.state)}
                           
                          </span>
                        </label>

                    </div>
                    {this.props.part.specialOrder && (
                    <div className="child-icon">
                          <span className="rp-part-details-desktop--info--special-order">
                            <span
                              className={`rpds-new-releases special-order-icon`}
                            />
                            <span>{i18n.t('general.nonReturn')}</span>
                          </span>
                       
                    </div>
                     )}
                    {this.props.part.isDropShip && (
                    <div className="child-icon">
                          <span className="rp-part-details-desktop--info--special-order">
                            <span><img src={dropShipIcon} alt="icon" className="dropship-icon" /></span>
                            <span>{i18n.t('general.dropShipOnly')}</span>
                          </span>
                    </div>
                    )}
                    <div className="child-icon">
                    {env.REACT_APP_BASE_ENVIRONMENT === 'CA' &&
                          this.props.backorder && (
                            <div className="rp-part-details-desktop--rush-flag">
                              <Checkbox
                                name={t('checkoutPage.rushThisItem')}
                                value={''}
                                checked={this.props.rushOrder}
                                onChange={this.handleRushOrderChange}
                              />
                            </div>
                          )}
                    </div>
                  </div>
                  {/*<div className="rp-part-details-desktop--info--stock-text">
                    <div className="rp-part-details-desktop--info--stock">
                      <div className="rp-part-details-status-section">
                        <label className="rp-part-details-desktop--info--stock-label">
                          <span
                            title={this.props.part.stateDescription}
                            className={this.getIcon()}
                          />
                          <span
                            title={this.props.part.stateDescription}
                            className="rp-part-details-state"
                          >
                             {this.props.part.state} 
                            {this.props.part.state.toLowerCase() ==='special order' &&
                             i18n.t('common.nonReturn')
                            }
                          </span>
                        </label>
                        {this.props.part.specialOrder && (
                          <span className="rp-part-details-desktop--info--special-order">
                            <span
                              className={`rpds-new-releases special-order-icon`}
                            />
                            <span>{i18n.t('common.nonReturn')}</span>
                          </span>
                        )}
                        {env.REACT_APP_BASE_ENVIRONMENT === 'CA' &&
                          this.props.backorder && (
                            <div className="rp-part-details-desktop--rush-flag">
                              <Checkbox
                                name={t('checkoutPage.rushThisItem')}
                                value={''}
                                checked={this.props.rushOrder}
                                onChange={this.handleRushOrderChange}
                              />
                            </div>
                          )}
                      </div>
                      
                    </div>
                  </div> */}
                  {this.props.isLoggedIn && (
                    <div className="rp-part-details-desktop--info--prices">
                      {!this.props.showOnlyMSRP && (
                        <div className="rp-part-details-desktop--info--prices-one price">
                          <label className="rp-part-details-desktop--info--price-title">
                            {t('myFavourites.yourPrice')}
                          </label>
                          <p className="rp-part-details-desktop--info--price">
                            {accounting.formatMoney(this.props.part.price)}
                          </p>
                        </div>
                      )}
                      <div className="rp-part-details-desktop--info--prices-one">
                        <label className="rp-part-details-desktop--info--price-title">
                          {(t('common.msrp') as string).toUpperCase()}
                        </label>
                        <p className="rp-part-details-desktop--info--price">
                          {accounting.formatMoney(this.props.part.msrp)}
                        </p>
                      </div>
                    </div>
                  )}
                  <div className="rp-part-details-desktop--info--extra">                  
                    {this.props.part.extraProducts.length > 0 && (
                      (getExtraStatus(this.props.part.extraProducts)==="DONOTSHOW") || (this.setCurrentTab() === 0 && getExtraComponentCode(this.props.part.extraProducts) === "OVERSIZE")  ?
                      <div>&nbsp;</div>
                      :
                      <div>                        
                        <span className={'rpds-error stock-error-icon'} />
                        <span className="rp-part-details-desktop--info--extra-title">
                          {getExtraStatus(this.props.part.extraProducts)}
                        </span>
                      </div>
                    )}
                    
                   
                  {this.props.part.extraTotalAmount-getExtraComponentCodePrice(this.props.part.extraProducts) > 0 && this.setCurrentTab() === 0 ?
                    <p className={'rp-part-details-desktop--info--extra-text'} >
                        {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                          ? `An extra charge of ${accounting.formatMoney(
                              this.props.part.extraTotalAmount-getExtraComponentCodePrice(this.props.part.extraProducts)
                            )} may apply at checkout.`
                          : `An extra charge of ${accounting.formatMoney(
                              this.props.part.extraTotalAmount-getExtraComponentCodePrice(this.props.part.extraProducts)
                            )} will apply at checkout.`}
                      </p>:"" }
                      {this.props.part.extraTotalAmount > 0 && this.setCurrentTab() !== 0 ?
                        <p
                        className={'rp-part-details-desktop--info--extra-text'}
                      >
                        {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                          ? `An extra charge of ${accounting.formatMoney(
                              this.props.part.extraTotalAmount
                            )} may apply at checkout.`
                          : `An extra charge of ${accounting.formatMoney(
                              this.props.part.extraTotalAmount
                            )} will apply at checkout.`}
                      </p>:""}
                  </div>
                </div>
              </div>
               {/* Short Description */}
               { this.props.part.longDesc!=="" &&
               <div className='rp-part-details-desktop-product-short-desc-text'>
                {this.state.isOpen ? 
                  <span dangerouslySetInnerHTML={{__html: `${this.props.part.longDesc}... `}}/> 
                  : 
                  this.props.part.longDesc.length > 135 ?
                  <span className="read-text" dangerouslySetInnerHTML={{__html: `${this.props.part.longDesc.slice(0, 135)}... `}}/> 
                  :
                  <span dangerouslySetInnerHTML={{__html: `${this.props.part.longDesc}`}}/>  
                }
                { this.props.part.longDesc.length > 135 &&
                <span
                onClick={this.state.isOpen ? this.handleToggleReadMore :this.props.handleScrollToLongDesc}
                className="read-or-hide"
                >
                {this.state.isOpen ? "Show Less" : "Read More"}
                </span>
                  }
                </div>
                }
                {/* End Short Description */}

                <div className='rp-part-details-desktop-product-short-desc-text'>
                {this.props.part.weight!==null  &&
                  <p><b>{i18n.t('myReturns.weight')} :</b> {this.props.part.weight}</p>
                }
                { this.props.part.length!==null  && this.props.part.width!==null && this.props.part.height!==null &&
                  <p>
                    <b>{i18n.t('common.dimesions')} : </b> 
                    {(parseFloat(this.props.part.length)/2.54).toFixed(2)}" L x  {(parseFloat(this.props.part.width)/2.54).toFixed(2)}" W x  {(parseFloat(this.props.part.height)/2.54).toFixed(2)}" H
                  </p>
                 }
                </div>

              {this.props.part.state !== 'No Longer Available' ? (
                <div>
                  {/* Product Alternates */}
                  {this.props.part.alternateParts.length>0 && (
                  <div className="alternate-row">
                    <div className="col">
                      <div className="rp-part-details-desktop--delivery-method-tabs-container">
                        <AlternatesParts
                          altParts={this.props.part.alternateParts}
                          defaultAltItemsToShow={3}
                        />
                      </div>
                    </div>
                  </div>
                  )}
                  {/* End Product Alternates */}
                 
                  <div className="row">
                    <div className="col">
                      <div className="rp-part-details-desktop--delivery-method-tabs-container">
                        <Tabs
                          currentTab={this.setCurrentTab()}
                          selectTab={this.selectTab}
                          tabTitles={tabTitles}
                          tabContents={tabContents}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <div className="rp-paret-details--form">
                        <form
                          ref={ref => (this.formRef = ref)}
                          onSubmit={this.handleSubmit}
                        >
                          <div className="rp-paret-details--form--title">
                            {t('product.additionalOptions')}:
                          </div>
                          <div className="row">
                            <div className="col form-inputs">
                              <label
                                className={
                                  this.state.disableShipmentMarking
                                    ? 'disabled'
                                    : ''
                                }
                              >
                                {t('myFavourites.shipmentMarking')}:
                              </label>
                              <input 
                                aria-label="Enter the optional marking to be placed on the shipment"
                                name="shipmentMarking"
                                type="text"
                                className={
                                  this.state.disableShipmentMarking
                                    ? 'disabled'
                                    : ''
                                }
                                value={this.props.shipmentMarking}
                                onChange={this.handleInputShipmentMarkingChange}
                                disabled={this.state.disableShipmentMarking}
                                maxLength={30}
                              />
                            </div>
                            {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                              <div className="col form-inputs">
                                <label>
                                  {t('product.ticket')} /{' '}
                                  {t('product.dispatch#')}:
                                </label>
                                <input
                                  name="ticketNumber"
                                  type="text"
                                  value={this.props.ticketNumber}
                                  onChange={this.handleInputTicketNumberChange}
                                  maxLength={10}
                                />
                              </div>
                            ) : (
                              this.props.warranties.length > 0 && (
                                <React.Fragment>
                                  <div className="col form-inputs">
                                    <label>
                                      {t('product.warrantyProvider')}:
                                    </label>
                                    <div
                                      onClick={this.handleShowDropDown}
                                      className="combobox dropdown"
                                    >
                                      <div
                                        tabIndex={0}
                                        className="dropdown-box"
                                      >
                                        {this.props.warrantyProvider}
                                      </div>
                                      <div tabIndex={-1} className="downarrow">
                                        <span className="rpds-expand-more" />
                                      </div>
                                      {this.state.showDropDown && (
                                        <div className="dropdown-list">
                                          <div
                                            className="dropdown-list-option"
                                            key={'none'}
                                            onClick={e =>
                                              this.handleSelectWarrantyProviderChange(
                                                {
                                                  warrantyClaimNumber: 'None',
                                                  providerNumberString: '',
                                                  providerNumber: null
                                                }
                                              )
                                            }
                                          >
                                            None
                                          </div>
                                          {this.props.warranties.map(
                                            warranty => (
                                              <div
                                                className="dropdown-list-option"
                                                key={warranty.providerNumber}
                                                onClick={e =>
                                                  this.handleSelectWarrantyProviderChange(
                                                    warranty
                                                  )
                                                }
                                              >
                                                {warranty.warrantyClaimNumber}
                                              </div>
                                            )
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {this.state.disableShipmentMarking && (
                                    <div className="col-3 form-inputs">
                                      <label>
                                        {t('myFavourites.dispatch')}/
                                        {t('product.claims_plural')}:
                                      </label>
                                      <input
                                        name="claims"
                                        type="text"
                                        value={this.props.claims}
                                        onChange={this.handleInputClaimsChange}
                                        // maxLength={30}
                                      />
                                    </div>
                                  )}
                                </React.Fragment>
                              )
                            )}
                          </div>
                          <div className="divider" />
                          <div className="row rp-part-details-desktop--form--buttons">
                            <button  type="button" tabIndex={0} className="col-6 partDetails-button-add-to-list">
                              <AddToListMenu part={this.props.part as any} />
                            </button>
                            <div onKeyDown={this.handleKeyDown} role="button" tabIndex={0} className="col-6 partDetails-button-add-to-cart">
                              {this.getAddToCartButton()}
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="rp-parts-details-desktop--part-unavailable">
                  <div className="divider" />
                  <div className="rp-parts-details-desktop--part-unavailable--message">
                    <p className="rp-parts-details-desktop--part-unavailable--message-title">
                      {t('product.pleaseCallOurService')}
                    </p>
                    <p className="rp-parts-details-desktop--part-unavailable--message-department">
                      {t('common.customerService')}
                    </p>
                    {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                      <div>
                        <p>1-800-663-6060</p>
                        <a
                          className="rp-parts-details-desktop--part-unavailable--message-link"
                          href={'mailto:reliableinfo@reliableparts.com'}
                        >
                          reliableinfo@reliableparts.com
                        </a>
                      </div>
                    ) : (
                      <div>
                        <p>800-666-0313</p>
                        <a
                          className="rp-parts-details-desktop--part-unavailable--message-link"
                          href={'mailto:contactus.web@reliableparts.com '}
                        >
                          contactus.web@reliableparts.com
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PartDetailsDesktop;
